export const trimFun = (str, filterN) => {
    str = String(str).replace(/(^\s*)/g, '');

    if (filterN) {
        str = String(str).replace(/(\\n)/g, '');
    }

    return str;
};
